import React, { Component, Fragment } from 'react';

import { getAllUserIntegrations } from 'controllers/integrations';
import { connect } from 'react-redux';
import { Loader, Navigation, Snackbar } from 'common';
import './productInfoContainer.scss';
import { Box, Grid, Typography } from '@material-ui/core';
import ProductDetails from './productDetails/productDetails';
import { ArrowBack } from '@material-ui/icons';

class ProductInfoContainer extends Component {
  componentDidMount() {
    const { integrations } = this.props;

    if (!integrations.length) {
      getAllUserIntegrations();
    }
  }

  getSelectedProduct = () => {
    const { integrations, match } = this.props;
    const { productName } = match.params;
    const product = integrations.find(
      ({ integrationDto }) =>
        integrationDto.product.toLowerCase() === productName
    );

    if (product) {
      return {
        ...product.integrationDto,
        isActive: product.isActive,
        userIntegrationId: product.userIntegrationId,
      };
    }

    return false;
  };

  onClickBack = () => {
    const { history } = this.props;

    history.push('/integrations');
  };

  render() {
    const { integrations, integrationDisabled = false, history } = this.props;
    const productDetails = this.getSelectedProduct();

    if (!productDetails) {
      return <Loader />;
    }

    return (
      <Fragment>
        <div className="integrations-listing-wrapper">
          <Navigation />
          <Grid container spacing={2} justify="center">
            <Grid item xs={10}>
              <Box mt="76px" className="text-content">
                <Box className="back-arrow" onClick={this.onClickBack}>
                  <ArrowBack className="back-arrow-icon" />
                  <Typography className="back-arrow-text">Back</Typography>
                </Box>
                <ProductDetails
                  {...productDetails}
                  integrations={integrations}
                  history={history}
                />
              </Box>
            </Grid>
          </Grid>
        </div>
        <Snackbar
          open={integrationDisabled}
          message={`Integration has been ${
            productDetails.isActive ? 'enabled' : 'disabled'
          }.`}
          type="success"
          flag="integrationDisabled"
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  integrations: state.user.integrations,
  integrationDisabled: state.flags.integrationDisabled,
});

export default connect(mapStateToProps, null)(ProductInfoContainer);
